module.exports = __webpack_public_path__ + "img/img80.09ea9765.svg";